<div fxLayout="row" fxLayoutAlign="center start">
  <div fxFlex class="card-container">
    <app-itinerary-expenses-card
      title="Spesa minima"
      [expenses]="itinerary.expenses.min"
      [npax]="itinerary.npax"
    ></app-itinerary-expenses-card>
  </div>

  <div fxFlex class="card-container">
    <app-itinerary-expenses-card
      title="Spesa massima"
      [expenses]="itinerary.expenses.max"
      [npax]="itinerary.npax"
    ></app-itinerary-expenses-card>
  </div>
</div>
